﻿import { AccountSummaryGateway } from './accountSummary.gateway';
import { AccountSummaryViewModel } from './accountSummary.viewmodel';
import { SubmissionStateService } from '../../core/services/submissionStateService/submissionState.service';
import { ViewLockService } from '../../core/services/viewLockService/viewLock.service';
import IAppSettings from '../../../iApp.settings';

export class AccountSummaryController {

    private accountSummaryViewModel: AccountSummaryViewModel;

    static $inject = ['$window', "viewLockService", 'accountSummary.gateway', 'submissionStateService', 'appSettings'];

    constructor(private $window: ng.IWindowService,
        private viewLockService: ViewLockService,
        private accountSummaryGateway: AccountSummaryGateway,
        private submissionStateService: SubmissionStateService,
        private appSettings: IAppSettings) {

        this.activate();
    }

    private activate() {
        this.accountSummaryViewModel = new AccountSummaryViewModel();
        this.viewLockService.broadcast(1);
        this.accountSummaryGateway.loadAccountSummaryViewModel(this.accountSummaryViewModel)
            .then(() => {
                this.submissionStateService.submissionId = this.accountSummaryViewModel.submissions[0].id;
                if (this.accountSummaryViewModel.submissions[0].statusCId !== '137') {
                    this.submissionStateService.isReadOnly = true;
                }
                else {
                    this.submissionStateService.isReadOnly = false;
                }

            })
            .finally(() => this.viewLockService.broadcast(0));
    }
}
